module.exports = __webpack_public_path__ + "img/fuel-icon-01.0726aa46.gif";